import { LOCATOR_ALERTS } from '../../constants';
import Util from '../Util';
const opts = {
  filterable: true,
  sortable: false
};
const CONSTANTS = {
  ...LOCATOR_ALERTS
};
const alertLabels = () => ({
  [CONSTANTS.POSITION_PENDING]: 'Position Pending',
  [CONSTANTS.PENDING_AUTOMATIC_LOCATION_TRANSFER]: 'Pending Automatic Location Transfer',
  [CONSTANTS.DEVICE_HEALTH]: 'Device Health Problem',
  [CONSTANTS.END_OF_LIFE]: 'End of Life',
  [CONSTANTS.SUSPECTED_DRIVE_OFF]: 'Suspected Drive-Off',
  [CONSTANTS.NOT_REPORTING]: 'Not Reporting',
  [CONSTANTS.NON_OPERATIONAL]: 'Not Operational',
  [CONSTANTS.SOLD_LOW_BATTERY]: 'Sold with Low Battery',
  [CONSTANTS.SOLD_OFFLINE]: 'Sold Offline',
  [CONSTANTS.SUSPECTED_OFF_LOT]: 'Suspected Off Lot',
  [CONSTANTS.THEFT_RECOVERY_ACTIVATING]: 'Theft Recovery Activating',
  [CONSTANTS.THEFT_RECOVERY_ACTIVATED]: 'Theft Recovery Activated',
  [CONSTANTS.THEFT_RECOVERY_ENDING]: 'Theft Recovery Ending'
});
const alertVariants = {
  [CONSTANTS.POSITION_PENDING]: 'pillPrimary',
  [CONSTANTS.PENDING_AUTOMATIC_LOCATION_TRANSFER]: 'pill',
  [CONSTANTS.DEVICE_HEALTH]: 'pillWarning',
  [CONSTANTS.END_OF_LIFE]: 'pillError',
  [CONSTANTS.SUSPECTED_DRIVE_OFF]: 'pillWarning',
  [CONSTANTS.NOT_REPORTING]: 'pillError',
  [CONSTANTS.NON_OPERATIONAL]: 'pillError',
  [CONSTANTS.SOLD_LOW_BATTERY]: 'pillWarning',
  [CONSTANTS.SOLD_OFFLINE]: 'pillWarning',
  [CONSTANTS.SUSPECTED_OFF_LOT]: 'pillWarning',
  [CONSTANTS.THEFT_RECOVERY_ACTIVATING]: 'pillTheftActive',
  [CONSTANTS.THEFT_RECOVERY_ACTIVATED]: 'pillTheftActive',
  [CONSTANTS.THEFT_RECOVERY_ENDING]: 'pillTheftEnding'
};
export default {
  id: 'locator.alerts',
  name: 'locator.alerts',
  displayName: 'Locator Alerts',
  valueType: 'string',
  objectType: 'locator',
  blueprint: {},
  getOption: key => {
    return opts[key];
  },
  get: obj => {
    const toReturn = [];
    const locatorAlerts = obj?.data?.locatorAlerts || [];
    if (Util.isLocatorNotReporting(obj)) {
      toReturn.push(CONSTANTS.NOT_REPORTING);
    }
    Object.values(CONSTANTS).forEach(val => {
      if (locatorAlerts[val]) {
        toReturn.push(val);
      }
    });
    return toReturn;
  }
};
export { alertLabels, alertVariants, CONSTANTS };